import React, { useEffect } from 'react'
import toast from 'react-hot-toast'

import { COLORS, PRODUCT_SELECTION_TYPE, SINGLE_SELECTION } from '@common'
import ProductSelectionSelector from '../ProductSelectionSelector'
import SelectionQuantityControl from './SelectionQuantityControl'

const SelectionBlock = React.memo(({ selection, value, onChange, options }) => {
    const minSelection =
        selection.type === PRODUCT_SELECTION_TYPE.MINIMUM ? 2
        : selection.type === PRODUCT_SELECTION_TYPE.TAKEAWAY ? 1
        : 0
    const isSelectedMinimum = value?.length >= minSelection
    const isRequired = selection.isRequired
    const selectionName = selection.name ?? ''
    const textSelection =
        selection.type === PRODUCT_SELECTION_TYPE.SINGLE ? `${selectionName} (Optional)`
        : selection.type === PRODUCT_SELECTION_TYPE.MINIMUM ? 'Select your options (minimum 2)'
        : selection.type === PRODUCT_SELECTION_TYPE.TAKEAWAY ? selectionName
        : selection.type === PRODUCT_SELECTION_TYPE.NORMAL ? selectionName
        : `${selectionName} (Optional)`

    useEffect(() => {
        if (selection.type === PRODUCT_SELECTION_TYPE.TAKEAWAY) {
            const activeOption = options.find(o => !o.isDisabled)
            onChange(selection.id, [activeOption || options[0]])
        }

        // eslint-disable-next-line
    }, [selection, options])

    const _onChange = val => {
        if (selection.quantity > 1 && val.length > selection.quantity) {
            toast(`This selection is limited to ${selection.quantity}`, {
                duration: 5000,
                icon: <i className="bx bx-sm bx-error text-danger"></i>,
            })
        } else {
            onChange(selection.id, val)
        }
    }

    const _renderQuantityControl = () => {
        if (!value) return null
        const isSingle = SINGLE_SELECTION.includes(selection.type) || selection.quantity === 1

        if (isSingle) {
            if (!value?.maxQuantity) return null
            return (
                <SelectionQuantityControl
                    label={value.label}
                    quantity={value.quantity || 1}
                    maxQuantity={value.maxQuantity}
                    onQuantityChange={newQuantity => {
                        onChange(selection.id, { ...value, quantity: newQuantity })
                    }}
                />
            )
        } else {
            const targetList = value?.filter(item => item.maxQuantity > 1 || item.maxQuantity !== null)
            if (!targetList?.length) return null

            return targetList?.map(item => (
                <SelectionQuantityControl
                    key={item.value}
                    // className="mt-3"
                    label={item.label}
                    quantity={item.quantity || 1}
                    maxQuantity={item.maxQuantity}
                    onQuantityChange={newQuantity => {
                        onChange(
                            selection.id,
                            value.map(val => (val.value === item.value ? { ...val, quantity: newQuantity } : val))
                        )
                    }}
                />
            ))
        }
    }

    return (
        <div key={selection.id} className="selection-container">
            <div className="selection-header">
                <h6>
                    {textSelection}
                    {isRequired && <span className="required-mark">*</span>}
                </h6>
                {isRequired && isSelectedMinimum && (
                    <i className="bx bx-check-circle" style={{ color: COLORS.PRIMARY, fontSize: '20px' }}></i>
                )}
            </div>
            <ProductSelectionSelector
                value={value}
                onChange={_onChange}
                options={options}
                type={selection.type}
                quantity={selection.quantity}
            />
            <div className="mt-3 ">{_renderQuantityControl()}</div>
        </div>
    )
})

export default SelectionBlock
